<script setup lang="ts">
import { ref } from "vue"
import AppSidebar from "./AppSidebar.vue"
import AppTopBar from "./AppTopBar.vue"
import AppDock from "./AppDock.vue"
import AppDrawer from "./AppDrawer.vue"
import ArticleAnalysisBanner from "../../components/ArticleAnalysisBanner.vue"

const drawerOpen = ref(false)
</script>

<template>
  <div class="min-h-dvh bg-base-200">
    <a
      href="#main-content"
      class="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 btn btn-primary btn-sm"
    >Zum Inhalt springen</a>
    <div class="max-w-screen-2xl mx-auto min-h-dvh flex">
      <!-- Desktop sidebar -->
      <AppSidebar class="hidden lg:block" />
      <!-- Main column -->
      <div class="flex-1 min-w-0 flex flex-col bg-base-100">
        <AppTopBar />
        <ArticleAnalysisBanner />
        <main id="main-content" tabindex="-1" class="flex-1 lg:px-6 py-6 pb-24 lg:pb-6">
          <router-view />
        </main>
      </div>
    </div>
    <AppDock @open-drawer="drawerOpen = true" />
    <AppDrawer v-model:open="drawerOpen" />
  </div>
</template>
